import React, { useRef } from 'react';
var VeltNotificationsPanelContentListItem = function (props) {
    var notification = props.notification, listItemTemplate = props.listItemTemplate, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-list-item", { ref: ref, notification: notification ? (typeof notification === 'string' ? notification : JSON.stringify(notification)) : undefined, "list-item-template": listItemTemplate ? (typeof listItemTemplate === 'string' ? listItemTemplate : JSON.stringify(listItemTemplate)) : undefined }, children));
};
export default VeltNotificationsPanelContentListItem;
